// extracted by mini-css-extract-plugin
export var highlight = "mapPin-module--highlight--94da6";
export var pin = "mapPin-module--pin--85944";